import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody47';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy47 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Annual performance </h2><h4> reporting framework</h4>";

  return (
    <>
        <Helmet>
        <title>Annual performance reporting framework</title>
        <meta property="og:title" content="Annual performance reporting framework" />
        <meta property='og:description' content='Annual performance reporting framework'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy47" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy47
